import { ErrorType } from "../store";
import AuthTypes from "./AuthTypes";

interface AuthState {
  loading: boolean;
  error: ErrorType | null;
  token: string | null;
  user: any | null;

  memberByEmailLoading: boolean;
  memberByEmailError: ErrorType | null;
  memberByEmail: any | null;

  signupLoading: boolean;
  signupError: ErrorType | null;

  verifyLoading: boolean;
  verifyError: ErrorType | null;

  adminLoginLoading: boolean;
  adminLoginError: ErrorType | null;
  admin: any | null;
  adminToken: string | null;

  forgotPasswordOTPLoading: boolean;
  forgotPasswordOTPError: ErrorType | null;
  forgotPasswordOTP: any | null;

  resetPasswordLoading: boolean;
  resetPasswordError: ErrorType | null;
  resetPassword: any | null;

  getBuildingsByZipCodeLoading: boolean;
  getBuildingsByZipCodeError: ErrorType | null;
  getBuildingsByZipCodeData: any[] | null;

  updateFirstLoginPasswordLoading: boolean;
  updateFirstLoginPasswordError: ErrorType | null;
  updateFirstLoginPasswordData: any | null;
}

const initialState: AuthState = {
  loading: false,
  error: null,
  token: null,
  user: null,

  memberByEmailLoading: false,
  memberByEmailError: null,
  memberByEmail: null,

  signupLoading: false,
  signupError: null,

  verifyLoading: true,
  verifyError: null,

  adminLoginLoading: false,
  adminLoginError: null,
  admin: null,
  adminToken: null,

  forgotPasswordOTPLoading: false,
  forgotPasswordOTPError: null,
  forgotPasswordOTP: null,

  resetPasswordLoading: false,
  resetPasswordError: null,
  resetPassword: null,

  getBuildingsByZipCodeLoading: false,
  getBuildingsByZipCodeError: null,
  getBuildingsByZipCodeData: null,

  updateFirstLoginPasswordLoading: false,
  updateFirstLoginPasswordError: null,
  updateFirstLoginPasswordData: null,
};

const authReducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case AuthTypes.LOGIN_LOADING:
      return {
        ...state,
        user: null,
        token: null,
        loading: true,
        error: null,
      };

    case AuthTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        token: action.payload.token,
        user: action.payload.user,
      };

    case AuthTypes.LOGIN_ERROR:
      return {
        ...state,
        user: null,
        token: null,
        loading: false,
        error: JSON.parse(action.payload),
      };

    case AuthTypes.VERIFY_LOADING:
      return {
        ...state,
        verifyLoading: true,
        verifyError: null,
        user: null,
        token: null,
      };

    case AuthTypes.VERIFY_SUCCESS:
      return {
        ...state,
        verifyLoading: false,
        verifyError: null,
        token: action.payload.token,
        user: action.payload.user,
      };

    case AuthTypes.VERIFY_ERROR:
      return {
        ...state,
        verifyLoading: false,
        verifyError: JSON.parse(action.payload),
        user: null,
        token: null,
      };

    case AuthTypes.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        loading: false,
        error: null,
        verifyLoading: false,
        verifyError: null,
      };

    case AuthTypes.GET_MEMBER_BY_EMAIL_LOADING:
      return {
        ...state,
        memberByEmailLoading: true,
        memberByEmailError: null,
        memberByEmail: null,
      };

    case AuthTypes.GET_MEMBER_BY_EMAIL:
      return {
        ...state,
        memberByEmailLoading: false,
        memberByEmailError: null,
        memberByEmail: action.payload,
      };

    case AuthTypes.GET_MEMBER_BY_EMAIL_ERROR:
      return {
        ...state,
        memberByEmailLoading: false,
        memberByEmailError: JSON.parse(action.payload),
        memberByEmail: null,
      };

    case AuthTypes.SIGNUP_LOADING:
      return {
        ...state,
        signupLoading: true,
        signupError: null,
      };

    case AuthTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        signupLoading: false,
        signupError: null,
        token: action.payload.token,
      };

    case AuthTypes.SIGNUP_ERROR:
      return {
        ...state,
        signupLoading: false,
        signupError: JSON.parse(action.payload),
      };

    case AuthTypes.ADMIN_LOGIN_LOADING:
      return {
        ...state,
        adminLoginLoading: true,
        adminLoginError: null,
        admin: null,
        adminToken: null,
      };

    case AuthTypes.ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        adminLoginLoading: false,
        adminLoginError: null,
        admin: action.payload.admin,
        adminToken: action.payload.token,
      };

    case AuthTypes.ADMIN_LOGIN_ERROR:
      return {
        ...state,
        adminLoginLoading: false,
        adminLoginError: JSON.parse(action.payload),
        admin: null,
        adminToken: null,
      };

    case AuthTypes.LOGOUT_ADMIN:
      return {
        ...state,
        admin: null,
        adminToken: null,
        adminLoginLoading: false,
        adminLoginError: null,
        verifyLoading: false,
        verifyError: null,
      };

    case AuthTypes.ADMIN_VERIFY_LOADING:
      return {
        ...state,
        verifyLoading: true,
        verifyError: null,
        admin: null,
        adminToken: null,
      };

    case AuthTypes.ADMIN_VERIFY_SUCCESS:
      return {
        ...state,
        verifyLoading: false,
        verifyError: null,
        admin: action.payload.admin,
        adminToken: action.payload.token,
      };

    case AuthTypes.ADMIN_VERIFY_ERROR:
      return {
        ...state,
        verifyLoading: false,
        verifyError: JSON.parse(action.payload),
        admin: null,
        adminToken: null,
      };

    case AuthTypes.FORGOT_PASSWORD_OTP_LOADING:
      return {
        ...state,
        forgotPasswordOTPLoading: true,
        forgotPasswordOTPError: null,
        forgotPasswordOTP: null,
      };

    case AuthTypes.FORGOT_PASSWORD_OTP_SUCCESS:
      return {
        ...state,
        forgotPasswordOTPLoading: false,
        forgotPasswordOTPError: null,
        forgotPasswordOTP: action.payload,
      };

    case AuthTypes.FORGOT_PASSWORD_OTP_CLEAR:
      return {
        ...state,
        forgotPasswordOTPLoading: false,
        forgotPasswordOTPError: null,
        forgotPasswordOTP: null,
      };

    case AuthTypes.FORGOT_PASSWORD_OTP_ERROR:
      return {
        ...state,
        forgotPasswordOTPLoading: false,
        forgotPasswordOTPError: JSON.parse(action.payload),
        forgotPasswordOTP: null,
      };

    case AuthTypes.RESET_PASSWORD_LOADING:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordError: null,
        resetPassword: null,
      };

    case AuthTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordError: null,
        resetPassword: action.payload,
      };

    case AuthTypes.RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordError: JSON.parse(action.payload),
        resetPassword: null,
      };

    case AuthTypes.GET_MEMBER_BY_EMAIL_CLEAR:
      return {
        ...state,
        memberByEmailLoading: false,
        memberByEmailError: null,
        memberByEmail: null,
      };

    case AuthTypes.GET_BUILDINGS_BY_ZIP_CODE_LOADING:
      return {
        ...state,
        getBuildingsByZipCodeLoading: true,
        getBuildingsByZipCodeError: null,
        getBuildingsByZipCodeData: null,
      };

    case AuthTypes.GET_BUILDINGS_BY_ZIP_CODE_SUCCESS:
      return {
        ...state,
        getBuildingsByZipCodeLoading: false,
        getBuildingsByZipCodeError: null,
        getBuildingsByZipCodeData: action.payload,
      };

    case AuthTypes.GET_BUILDINGS_BY_ZIP_CODE_ERROR:
      return {
        ...state,
        getBuildingsByZipCodeLoading: false,
        getBuildingsByZipCodeError: JSON.parse(action.payload),
        getBuildingsByZipCodeData: null,
      };

    case AuthTypes.UPDATE_FIRST_LOGIN_PASSWORD_LOADING:
      return {
        ...state,
        updateFirstLoginPasswordLoading: true,
        updateFirstLoginPasswordError: null,
        updateFirstLoginPasswordData: null,
      };

    case AuthTypes.UPDATE_FIRST_LOGIN_PASSWORD_SUCCESS:
      return {
        ...state,
        updateFirstLoginPasswordLoading: false,
        updateFirstLoginPasswordError: null,
        updateFirstLoginPasswordData: action.payload,
      };

    case AuthTypes.UPDATE_FIRST_LOGIN_PASSWORD_ERROR:
      return {
        ...state,
        updateFirstLoginPasswordLoading: false,
        updateFirstLoginPasswordError: JSON.parse(action.payload),
        updateFirstLoginPasswordData: null,
      };

    default:
      return state;
  }
};

export default authReducer;
